export default __webpack_public_path__ + "static/media/SubscriptionIcon.26379006.png";